import axios from 'axios';

const state = {};
const getters = {};
const mutations = {};

const actions = {
  async getAllSMSCampaigns(_obj, params) {
    const res = await axios.get('api/sms/campaigns/', { params });
    return res.data;
  },
  async getSMSCampaign(_obj, id) {
    const res = await axios.get(`api/sms/campaigns/${id}/`);
    return res.data;
  },
  async createSMSCampaign(_obj, data) {
    return axios.post('api/sms/campaigns/', data);
  },
  async updateSMSCampaign(_obj, { id, data }) {
    return axios.patch(`api/sms/campaigns/${id}/`, data);
  },
  async deleteSMSCampaign(_obj, id) {
    return axios.delete(`api/sms/campaigns/${id}/`);
  },
  async sendSMSCampaign(_obj, id) {
    return axios.post(`api/sms/campaigns/${id}/send/`);
  },
  async scheduleSMSCampaign(_obj, { id, data }) {
    return axios.post(`api/sms/campaigns/${id}/schedule/`, data);
  },
  async getSMSCampaignStats(_obj, id) {
    const res = await axios.get(`api/sms/campaigns/${id}/stats/`);
    return res.data;
  },
  async getSMSCampaignRecipients(_obj, id) {
    const res = await axios.get(`api/sms/campaigns/${id}/recipients/`);
    return res.data;
  },
  async getSMSRecipientEvents(_obj, { campaignId, recipientId }) {
    const res = await axios.get(`api/sms/campaigns/${campaignId}/recipients/${recipientId}/events/`);
    return res.data;
  },
  async cloneSMSCampaign(_obj, id) {
    return axios.post(`api/sms/campaigns/${id}/clone/`);
  },
};

export const smsCampaign = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
